// Gallery.js
import React from 'react';
import '../styles/Gallery.css';

function Gallery() {
  const images = [
    'https://via.placeholder.com/300x200?text=Image+1',
    'https://via.placeholder.com/300x200?text=Image+2',
    'https://via.placeholder.com/300x200?text=Image+3',
    'https://via.placeholder.com/300x200?text=Image+4'
  ];

  return (
    <section className="gallery-section">
      <h2>Gallery</h2>
      <div className="gallery-grid">
        {images.map((src, idx) => (
          <div key={idx} className="gallery-item">
            <img src={src} alt={`Placeholder ${idx + 1}`} />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;
